import {
  Hero,
  ServiceTimes,
  FeaturedEvents,
  LatestSermon,
  NextSteps,
  QuickActions,
  NewHereBanner,
} from '../../components/home'

const Home = () => {
  return (
    <>
      <Hero />
      <ServiceTimes />
      <FeaturedEvents />
      <LatestSermon />
      <NewHereBanner />
      <NextSteps />
      <QuickActions />
    </>
  )
}

export default Home
